import { render } from "./auth.vue?vue&type=template&id=5598f220&scoped=true"
import script from "./auth.vue?vue&type=script&lang=js"
export * from "./auth.vue?vue&type=script&lang=js"

import "./auth.vue?vue&type=style&index=0&id=5598f220&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5598f220"]])

export default __exports__